/**
 * How many sessions are rendered before the "show more" row appears.
 *
 * The server returns every unexpired session at once, and a user who signs in
 * repeatedly over a year can reach hundreds. Each row mounts several MUI
 * components and parses a user agent, so rendering the whole list at once is
 * enough to freeze the low-end devices this runs on.
 */
export const SESSIONS_PAGE_SIZE = 5
